import React, { useEffect, useRef, useState } from "react";
import { Modal, Button } from "antd";
import { useReactToPrint } from "react-to-print";
import { toWords } from "number-to-words";
import logoHeader from "../../../assets/header_letterhead.png";
import logoFooter from "../../../assets/footer.png";
import axios from "axios";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";

const SalesBillTemplate = ({ visible, modalClose, data }) => {
  const printRef = useRef();
  const [leadUser, setLeadUser] = useState(null);
  const [empImage, setEmpImage] = useState(null);
  useEffect(() => {
    const fetchLeadUser = async () => {
      const response = await axios(`${config?.baseUrl}/employee/lead_user/`, {
        headers: authHeader(),
      });
      if (response?.data) {
        setLeadUser(response?.data);
      }
    };
    fetchLeadUser();
  }, [data]);

  useEffect(() => {
    if (leadUser?.signature) {
      axios
        .get(`${config.baseUrl}/api/s3-file-url/`, {
          headers: authHeader(),
          params: {
            file_key: leadUser?.signature,
            file_type: "image",
          },
        })
        .then((response) => {
          setEmpImage(response?.data?.imgUrl);
        });
    }
  }, [leadUser?.signature]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Purchase_Order_${data?.po_reference}`,
    pageStyle: `
      @page {
        size: A4;
        margin: 0;
        @top-left {
          content: element(po-header);
        }
      }

      header.po-header {
        position: running(po-header);
      }

      @media print {
        body {
          -webkit-print-color-adjust: exact;
          font-family: sans-serif;
          font-size: 14px;
          margin: 0;
        }

        .printable-content {
          overflow: visible !important;
          max-height: none !important;
        }

        table {
          border-collapse: collapse;
          width: 100%;
          page-break-inside: auto;
        }
        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }
        th, td {
          border: 1px solid #000;
          
          font-size: 14px;
        }

        .ant-modal-content {
          overflow: visible !important;
        }

        .no-print {
          display: none !important;
        }

        /* Fixed footer at bottom */
        .po-footer-fixed {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
        }
      }
    `,
  });

  return (
    <Modal open={visible} onCancel={modalClose} footer={false} width="40%">
      <div ref={printRef}>
        {/* Header for printing */}
        <header className="po-header" style={{ textAlign: "left" }}>
          <img src={logoHeader} alt="Header" style={{ width: "40%" }} />
        </header>

        {/* Scrollable content for on-screen modal */}
        <div
          className="printable-content"
          style={{
            maxHeight: "800px",
            overflowY: "auto",
            fontSize: "14px",
            marginTop: "80px",
          }}
        >
          <div className="w-full p-3 text-sm leading-relaxed font-sans">
            <div className="ps-5">
              <div className="mt-4  mb-2">
                <p className="m-0">
                  Bill: {data?.sale_reference} <br />
                  {data?.created_at
                    ? new Date(data.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : ""}
                </p>
              </div>

              <p>
                Bill To
                <strong>
                  <br />
                  {data?.institutional?.institutional_buyer_name ||
                    data?.regular?.name ||
                    data?.retailer?.name}
                  <br />
                  {data?.institutional?.institutional_buyer_address ||
                    data?.regular?.address ||
                    data?.retailer?.address}
                </strong>
              </p>

              <p className="m-0 mb-2">
                Subject: <strong>Supply Bill</strong>
              </p>

              <div className="mb-1">
                <p>
                  Dear Sir, <br />
                  Our company <strong>Agrigate Network Limited</strong> has been
                  supplying{" "}
                  <strong>
                    {data?.invoice_products
                      ?.map((item) => item?.product?.product_name)
                      .join(", ")}
                  </strong>{" "}
                  to your company{" "}
                  {data?.institutional?.institutional_buyer_name ||
                    data?.regular?.name ||
                    data?.retailer?.name}{" "}
                  as Egg supplier.
                </p>
              </div>

              <table className="w-full border-collapse mb-4 text-sm">
                <thead>
                  <tr className="border">
                    <th className="border p-2 text-center">Sl</th>
                    <th className="border p-2 text-center">Date</th>
                    <th className="border p-2">Description</th>
                    <th className="border p-2 text-center">Challan</th>
                    <th className="border p-2 text-right">Pcs</th>
                    <th className="border p-2 text-right">Unit Price(TK)</th>
                    <th className="border p-2 text-right">Amount (TK)</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.invoice_products.map((item, index) => (
                    <tr key={index} className="border">
                      <td className="border p-2 text-center">{index + 1}</td>
                      <td className="border p-2 text-center">
                        {item?.created_at?.substring(0, 10)}
                      </td>
                      <td className="border p-2">
                        {item?.product?.product_name}
                      </td>
                      <td className="border p-2 text-center">
                        {data?.challan}
                      </td>
                      <td className="border p-2 text-right">
                        {Number(item?.quantity)?.toLocaleString()}
                      </td>
                      <td className="border p-2 text-right">
                        {item?.sale_rate?.toFixed(2)}
                      </td>
                      <td className="border p-2 text-right">
                        {Number(item?.product_total_price)?.toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="mb-4 font-bold text-right">
                <strong>
                  Total Price:{" "}
                  {Number(data?.total_price)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </strong>
              </div>

              <div className="mb-4" style={{ textTransform: "capitalize" }}>
                <strong>In Word: {toWords(data?.total_price)} Taka Only</strong>
              </div>
              <p>
                Therefore, please arrange to pay this bills as soon as possible.
              </p>

              <div className="mt-5" style={{fontSize: "12px"}}>
                <img className="mb-2" src={empImage} alt="Signature" style={{ width: "100px" }} />
                <p>
                  Sincerely, <br />
                  <strong>
                    {leadUser?.user_info?.first_name +
                      " " +
                      leadUser?.user_info?.last_name}{" "}
                  </strong>
                  <br />
                  {leadUser?.designation}
                  <br />
                  {leadUser?.job_title}
                  <br />
                </p>
                <p></p>
                <p>Agrigate Network Limited</p>
              </div>
            </div>
          </div>
        </div>

        {/* Fixed Footer */}
        <div className="po-footer-fixed">
          <img src={logoFooter} alt="Footer" style={{ width: "100%" }} />
        </div>
      </div>

      {/* Print button */}
      <div className="no-print d-flex justify-content-center mt-3">
        <Button
          style={{
            backgroundColor: "#46604A",
            borderColor: "#46604A",
            color: "#fff",
          }}
          onClick={handlePrint}
          className="d-flex justify-center px-5"
        >
          Print
        </Button>
      </div>
    </Modal>
  );
};

export default SalesBillTemplate;
